import React from 'react';
import {
	Table,
	message,
	Popconfirm,
	Button,
	Icon,
	Input,
	Select,
	Form,
	Modal,
	Row,
	Col,
	Tooltip,
	Tag,
	Pagination,
	Typography,
	Divider,
	Statistic, Avatar
} from 'antd';
import { clientRecommendAc as Ac } from '../../../redux/actions';
import { connect } from 'react-redux';
import moment from 'moment';
import ModalRender from './ModalRender';
import ModalRecommendRender from './ModalRecommend';
import { server } from '../../../config/serverConfig';
import SearchRender from './SearchRender';
import { download, download2 } from "../../../utils";
import { color } from "echarts/src/export";
const { Text } = Typography;
function RenderBase({ appRd, story, set, create, get, update, recommend }) {


	//导入本组件所需参数变量
	const { data, dataLoading, dataFetchProps, selectedRows, selectedRowKeys, modalVisible, modalType, selectedRow, selectedRowIndex, pagination, searchProps, modalRecommendVisible } = story;
	const { loginData, screenType, loginUserRoleAuth } = appRd;
	const { roleid, groupid, user_name } = loginData;

	//dataFetchProps
	if (dataLoading) {
		//全局尽量统一通过修改dataLoading来刷新数据，以减少数据不准一。
		// 加载loading
		get({ ...dataFetchProps, ...searchProps });

	}

	//刷新按钮强制刷新，需要提示
	const refreshData = async () => {
		let msg = await get({ ...dataFetchProps, ...searchProps });
		message.info(msg);
	}



	//定义表头
	const columns = [{
		title: 'id',
		dataIndex: 'id',
		key: 'id',
		className: 'align_center', width: 60
	},{
		title: '产品模式',
		dataIndex: 'guarantee_type',
		key: 'guarantee_type',
		width: 120,
		render: (text, record) => (
			<div>
				{text !== undefined && text !== null ? (
					<span>
          <Avatar size="small" style={{ marginRight: 8 }}>
            {text === 0 ? '企' : text === 1 ? '大' : ''}
          </Avatar>
          <span style={{ fontSize: '14px', fontWeight: 'normal', color: text === 0 ? '#1890ff' : text === 1 ? '#00bcd4' : 'inherit' }}>
            {text === 0 ? '企信宝' : text === 1 ? '大经宝' : ''}
          </span>
        </span>
				) : (
					''
				)}
			</div>
		),
	},{
		title: '客户名称',
		dataIndex: 'enterprise_name',
		width: 150,
		key: 'enterprise_name',
		render: (text, record) => (
		<div>
			{record.social_credit_code ?
				<Tooltip placement="topLeft" title={'营业执照:' + record.social_credit_code}>
					{/** 超出宽度换行 */}
					<Tag color="#2db7f5" style={{ maxWidth: "100%" }}>
						<div style={{ whiteSpace: "pre-wrap" }}>
							{text}
						</div>
					</Tag>
				</Tooltip>
				: text}
		</div>
		),
	}, {
		title: 'SAP编码',
		dataIndex: 'sap_no', width: 120,
		key: 'sap_no',
	}, {
		title: '社会信用代码',
		dataIndex: 'social_credit_code',
		key: 'social_credit_code',
		className: 'align_center', width: 170,
	}, {
		title: '分公司',
		dataIndex: 'subcompany',
		key: 'subcompany',
		className: 'align_center', width: 120,
	},	{
		title: '业务员',
		dataIndex: 'bizperson',
		key: 'bizperson',
		render: (text) => (
			<div>
				{text ? (
					<span>
               <Avatar size="small" style={{ marginRight: 8, backgroundColor: '#69c0ff', color: '#fff' }}>
  {text.charAt(0)}
</Avatar>
              <Statistic value={text} valueStyle={{ fontSize: '15px', fontWeight: 'bold' }} />
            </span>
				) : (
					''
				)}
			</div>
		),
		width: 80,
	}
		,  {
			title: '状态',
			dataIndex: 'status',
			width: 120,
			key: 'status',
			render: (text) => (
				<div>
					{text === '成功' ? (
						<Avatar size="small" style={{ marginRight: 8, backgroundColor: '#1890ff' }}>
							<Icon type="check" style={{ color: '#fff' }} />
						</Avatar>
					) : (
						<Avatar size="small" style={{ marginRight: 8, backgroundColor: '#f5222d' }}>
							<Icon type="close" style={{ color: '#fff' }} />
						</Avatar>
					)}
					{text}
				</div>
			),
		},/*{
		title: '担保额度',
		dataIndex: 'deposit_quota',
		key: 'deposit_quota', width: 180,
		render: text => <Statistic value={text / 100} precision={2} valueStyle={{ fontSize: '15px', fontWeight: 'bold' }} />,
	}, */{
		title: '申请额度',
		dataIndex: 'apply_quota',
		key: 'apply_quota', width: 180,
		render: text => <Statistic value={text / 100} precision={2} valueStyle={{ fontSize: '15px', fontWeight: 'bold' }} />,
	}, {
		title: '预授信额度',
		dataIndex: 'pre_credit_quota',
		key: 'pre_credit_quota', width: 180,
		render: text => <Statistic value={text / 100} precision={2} valueStyle={{ fontSize: '15px', fontWeight: 'bold' }} />,
	},{
			title: '客户归属',
			dataIndex: 'groups',
			key: 'groups',
			width: 100,
			render: (groups, record) => {
				const tags = [];

				if (groups && groups.includes('dj')) {
					tags.push(<Tag color="#1890ff">大经</Tag>);
				}
				if (groups && groups.includes('ytg')) {
					tags.push(<Tag color="#00bcd4">优特钢</Tag>);
				}

				return (
					<div>
						{tags}
					</div>
				);
			},
		},


		{
			title: '最新一次额度时间',
			dataIndex: 'm_clientCredit',
			key: 'client_credit',
			width: 180,
			render: (m_clientCredit, record) => {
				// 获取对象值的数组
				const creditArray = Object.values(m_clientCredit);

				// 初始化变量以存储最晚时间和对应记录
				let latestTime = 0;
				let latestRecord = null;

				// 遍历 creditArray 找到 guarantee_type 为 0 的记录中最晚的时间
				for (const item of creditArray) {
					if (item.guarantee_type === 0) {
						const currentAuditTime = new Date(item.audit_time).getTime();
						if (currentAuditTime > latestTime) {
							latestTime = currentAuditTime;
							latestRecord = item;
						}
					}
				}

				// 检查是否找到符合条件的记录
				if (latestRecord) {
					const time = moment(latestTime).format("YYYY-MM-DD HH:mm");
					return (
						<div>
							{time}
						</div>
					);
				} else {
					return null; // 如果没有符合条件的记录，返回 null 或其他你希望显示的内容
				}
			},
		}


	];


	const rowSelection = {
		selectedRowKeys,
		selectedRows,
		onSelect: (record, selected, selectedRows, nativeEvent) => {
			if (selected) {
				set({ selectedRowKeys: [record.id], selectedRow: record, selectedRows: [record] })
			} else { set({ selectedRowKeys: [], selectedRow: {}, selectedRows: [] }) }
		},
		//onChange: (selectedRowKeys, selectedRows) => { SET({selectedRowKeys, selectedRows}) }
	};



	const BtnHandle = async (e) => {
		if (e.target.name === 'create') {
			set({ modalVisible: true, modalType: 'create' });
		}
		if (e.target.name === 'update') {
			set({ modalVisible: true, modalType: 'update' });
		}
		if (e.target.name === 'push') {
			set({ modalRecommendVisible: true, modalType: 'update' });
		}

	}

	const formRenderProps = {
		onFinish(data) {
			// 1  先清空分页中原有的当前页，pagination.current =1
			// 2 将搜索内容更新到 searchProps内。
			// 3 更新dataLoading 为true。

			let paginationNew = { ...pagination }
			paginationNew.current = 1;

			set({ dataLoading: true, pagination: { ...paginationNew }, searchProps: data });
		}

	}
	pagination.onChange = (page, pageSize) => {
		if (isNaN(pageSize)) {
			//这是异常刷新，不记录任何值,比如排序刷新
			return;
		}
		let paginationNew = { ...pagination };
		paginationNew.current = page;  //如果page是1，直接提交即可
		paginationNew.pageSize = pageSize;
		set({ pagination: paginationNew, dataLoading: true });

	}

	pagination.onShowSizeChange = (current, size) => {
		let paginationNew = { ...pagination };
		let overcount = paginationNew.pageSize * (paginationNew.current - 1);

		paginationNew.current = 1 + parseInt(overcount / size);

		paginationNew.pageSize = size;
		set({ pagination: paginationNew, dataLoading: true });

	}
	const tableDefinition = {
		rowKey: 'id',
		loading: dataLoading,
		pagination: pagination,
		size: 'small',
		columns: columns,
		dataSource: data,
		//expandedRowRender: record => <p style={{ margin: 0}}>{JSON.stringify(record,['user_id','mobile','email','roleid','groupid','subgroup','mail_user_rule','mail_grp_rule'])}</p>,
		//rowSelection: rowSelection,
		onRow: (record, index) => { return { onClick: event => set({ selectedRow: record, selectedRowIndex: index }) } },
		rowClassName: (record, index) => index === selectedRowIndex ? 'selectedItem' : '',
		scroll: { x: 800, y: window.innerHeight - 370 },
	}

	const modalRenderProps = {

		item: modalType === 'create' ? {} : selectedRow,
		type: modalType,
		visible: modalVisible,
		onOk(data) {
			set({ modalVisible: false })
			if (modalType === 'create') {
				data.status = '待批准'
				data.guarantee_type = 0
				create(data).then(res => {
					message.info(res);
				})
			}

			if (modalType === 'update') {
				update(data, selectedRowIndex).then(res => {
					return message.info(res);

				});

			}


		},
		onCancel() {
			set({ modalVisible: false })
		},
	}

	const modalRecommendProps = {

		item: selectedRow,
		type: modalType,
		visible: modalRecommendVisible,
		async onOk(data) {
			try {
				data.status = '已推荐未成功';

				// 同步执行 update
				update(data, selectedRowIndex).then(res => message.info(res));
				set({ modalRecommendVisible: false });
				// 同步执行 recommend
				const res = await recommend({
					id: data.id,
					guarantee_type: data.guarantee_type,
					enterpriseName: data.enterprise_name,
					socialCreditCode: data.social_credit_code,
					depositQuota: data.deposit_quota,
					applyQuota: data.apply_quota,
					sap_no: data.sap_no,
				});

				// 处理 recommend 的结果
				message.info(res);


			} catch (error) {
				console.error('Error in onOk:', error);
				// 可以在控制台输出错误信息，帮助调试
			}
		},
		onReject(data) {

			set({ modalRecommendVisible: false })
			update({ status: '拒绝' }, selectedRowIndex).then(res => message.info(res));
		},
		onCancel() {
			set({ modalRecommendVisible: false })
		},
	}


	const ModalRenderGene = () => <ModalRender {...modalRenderProps} />;
	const ModalRecommendGene = () => <ModalRecommendRender {...modalRecommendProps} />;


	return (
		<div>
			<Row style={{ marginBottom: 10 }}>
				<Col span={24}><Input.Group compact size="large">
					<Button onClick={refreshData}  > <Icon type="sync" style={{ color: 'green' }} />刷新</Button>
					<Button onClick={BtnHandle} name='create' hidden={loginUserRoleAuth.indexOf('/client/recommend/btn001') == -1}> <Icon type="plus" />新客</Button>
					<Button onClick={BtnHandle} name='update' disabled={selectedRowIndex === -1} hidden={loginUserRoleAuth.indexOf('/client/recommend/btn002') == -1}> <Icon type="edit" />修改</Button>
					<Divider type={"vertical"} />
					{/*<Button onClick={BtnHandle} name='push'  disabled={selectedRow.status!=='待批准'}> <Icon type="check" />推荐</Button>*/}
					<Button onClick={BtnHandle} name='push' > <Icon type="check" />推荐</Button>

				</Input.Group>

				</Col>

			</Row>
			<Row>
				<Col span={24}>
					<SearchRender {...formRenderProps} />
				</Col>
			</Row>
			<Table className='logListTable' {...tableDefinition} />
			{modalVisible && <ModalRenderGene />}
			{modalRecommendVisible && <ModalRecommendGene />}



		</div>);


}

const mapStateToProps = (state) => {
	return {
		story: state.clientRecommendRd,
		appRd: state.appReducer
	}
}

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		set: (value) => dispatch(Ac.SET(value)),
		get: (value) => dispatch(Ac.GET(value)),
		create: (value) => dispatch(Ac.CREATE(value)),
		update: (value, index) => dispatch(Ac.UPDATE(value, index)),
		recommend: (value) => dispatch(Ac.RECOMMEND(value)),

	}
}

const ClientRecommend = connect(mapStateToProps, mapDispatchToProps)(RenderBase);

export default ClientRecommend;
